import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../theme/ISpcTheme';

export type CloseButtonClasses = 'icon' | 'closeIcon';

const closeButtonStyles = makeStyles<ISpcTheme, CloseButtonClasses>(
  theme => ({
    icon: {
      width: '100%',
      height: '100%',
      fill: theme.palette.primary.main,
    },
    closeIcon: {
      fill: theme.palette.common.white,
    },
  }),
  { name: 'SPC_CloseButton' },
);

export default closeButtonStyles;
